import { useNgSession } from "@allwyn/ng/ng-session";
import { useLocalStorage } from "@allwyn/storage/composables/use-storage";
import { useAsyncComponent } from "@allwyn/utils/composables/use-dynamic-component";

const storageName = "has-confirmed-age";
const store = useLocalStorage();

export const confirmAge = (): Promise<void> => {
    return new Promise((resolve, reject) => {
        if (useNgSession().isLoggedIn.value) {
            resolve();
            return;
        }

        const hasConfirmedAge = store.getItem(storageName);
        if (hasConfirmedAge) {
            resolve();
            return;
        }

        const { showDynamicComponent, hideDynamicComponent } = useAsyncComponent({
            asyncImport: () => import("./age-confirmation-popup.vue"),
            props: {
                onConfirm: () => {
                    store.setItem(storageName, "true", "essential");
                    resolve();
                    hideDynamicComponent();
                },
                onCancel: () => {
                    reject();
                    hideDynamicComponent();
                },
            },
            name: "Age Confirmation Popup",
        });
        showDynamicComponent();
    });
};
